import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-publication-uploaded',
  templateUrl: './publication-uploaded.component.html',
  styleUrls: ['./publication-uploaded.component.scss']
})
export class PublicationUploadedComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }
  @Input() public type;
  @Input() public bulkUpload;

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }

}
